import { CantileverButton } from 'components/CantileverButton'
import annotateVideo from 'features/kestrelViewer/tutorial/assets/Teapot-Annotate.mp4'
import clickToMoveVideo from 'features/kestrelViewer/tutorial/assets/Teapot-Move.mp4'
import panVideo from 'features/kestrelViewer/tutorial/assets/Teapot-Pan.mp4'
import React from 'react'

import {
  ButtonContainer,
  ControlContent,
  ControlDescription,
  ControlItem,
  ControlLabel,
  ControlsList,
  ControlVideo,
  Dialog,
  DialogTitle,
} from './TutorialStyledComponents'

interface ControlsDialogProps {
  onNext: () => void
  onPrevious: () => void
}

export const ControlsDialog: React.FC<ControlsDialogProps> = ({
  onNext,
  onPrevious,
}) => {
  return (
    <Dialog>
      <DialogTitle>Basic Model Controls</DialogTitle>
      <ControlsList>
        <ControlItem>
          <ControlVideo autoPlay loop muted playsInline>
            <source src={clickToMoveVideo} type='video/mp4' />
          </ControlVideo>
          <ControlContent>
            <ControlLabel>Navigate</ControlLabel>
            <ControlDescription>
              Double-click on the model to navigate around the model.
            </ControlDescription>
          </ControlContent>
        </ControlItem>
        <ControlItem>
          <ControlVideo autoPlay loop muted playsInline>
            <source src={panVideo} type='video/mp4' />
          </ControlVideo>
          <ControlContent>
            <ControlLabel>Orbit</ControlLabel>
            <ControlDescription>
              Click and drag to orbit around the clicked point. Orbit is the
              default navigation mode but this can be changed from the toolbar.
            </ControlDescription>
          </ControlContent>
        </ControlItem>
        <ControlItem>
          <ControlVideo autoPlay loop muted playsInline>
            <source src={annotateVideo} type='video/mp4' />
          </ControlVideo>
          <ControlContent>
            <ControlLabel>Adding Annotations</ControlLabel>
            <ControlDescription>
              Right click to add an annotation to the model.
              <br />
              <br />
              After adding a label, you can adjust the severity, damage type,
              and notes.
              <br />
              <br />
              Once an annotation is added, it will appear in the annotations
              panel.
            </ControlDescription>
          </ControlContent>
        </ControlItem>
      </ControlsList>
      <ButtonContainer>
        <CantileverButton onClick={onPrevious}>Previous</CantileverButton>
        <CantileverButton primary onClick={onNext}>
          Next
        </CantileverButton>
      </ButtonContainer>
    </Dialog>
  )
}
